"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasketBubbleWrapper = exports.AnimationWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const topNavHeightStyle = 'var(--top-nav-height, 0)';
const BasketBubbleWrapper = exports.BasketBubbleWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  width: theme.spacing(64),
  marginTop: 10,
  pointerEvents: 'none',
  position: 'fixed',
  top: 0,
  right: 15,
  transform: `translate(0, ${topNavHeightStyle})`,
  transition: `transform var(--top-nav-height-animation), 0.3s ease-in-out`,
  zIndex: 10000,
  [theme.breakpoints.up('sm')]: {
    right: 30
  },
  '& *': {
    boxSizing: 'border-box'
  }
}));
const AnimationWrapper = exports.AnimationWrapper = (0, _mui.styled)('div')(({
  ownerState
}) => ({
  transition: 'opacity 750ms',
  opacity: 0,
  ...(ownerState.state === 'entered' && {
    opacity: 1
  }),
  ...(ownerState.state === 'exiting' && {
    opacity: 0,
    transition: 'margin-top 300ms 950ms, opacity 1250ms',
    marginTop: -(_constants.bubbleHeight + 10)
  })
}));